import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const fondueSavoyarde: Recipe = {
  slug: 'fondue-savoyarde',
  title: 'Fondue savoyarde',
  category: 'salé',
  description: 'Une fondue savoyarde au comté et au vin blanc, pour 3 personnes.',
  image: image('fondue-savoyarde'),
  tags: ['comté', 'vin blanc', 'convivial'],
  meta: [
    { label: 'Préparation', value: '5 min' },
    { label: 'Cuisson', value: '20 min' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('comte-jeune', 'comté jeune', '200 g de comté jeune', {
        amount: 200,
        unit: 'g',
        shoppingKey: 'comté',
      }),
      ingredient('comte-moyen', 'comté moyen', '200 g de comté moyen', {
        amount: 200,
        unit: 'g',
        shoppingKey: 'comté',
      }),
      ingredient('comte-vieux', 'comté vieux', '200 g de comté vieux', {
        amount: 200,
        unit: 'g',
        shoppingKey: 'comté',
      }),
      ingredient('vin', 'vin blanc', '25 cl de vin blanc', {
        amount: 25,
        unit: 'cl',
        shoppingKey: 'vin blanc',
      }),
      ingredient('ail', 'ail', 'Ail, pour frotter le caquelon', { shoppingKey: 'ail' }),
    ]),
  ],
  steps: [
    'Râper le fromage.',
    'Frotter le caquelon avec de l’ail.',
    'Faire chauffer le vin dans le caquelon, en faisant bien attention à ce qu’il ne soit ni trop chaud, ni trop froid.',
    'Ajouter le fromage au fur et à mesure. Le fromage doit former des fils et non s’émietter.',
  ],
}
